/**
 * ARIA Attribute Sanitizer Service
 * Automatically removes invalid aria-selected attributes from role="button" elements
 * injected by third-party widgets like TrustMate to ensure 100% Lighthouse Accessibility compliance.
 */
export function initAriaFix() {
    let scheduled = false;

    const sanitize = () => {
        scheduled = false;
        document.querySelectorAll('[role="button"][aria-selected]').forEach(el => {
            el.removeAttribute('aria-selected');
        });
    };

    const scheduleSanitize = () => {
        if (!scheduled) {
            scheduled = true;
            if ('requestIdleCallback' in window) {
                requestIdleCallback(sanitize, { timeout: 1000 });
            } else {
                requestAnimationFrame(sanitize);
            }
        }
    };

    // Initial pass
    scheduleSanitize();

    // Observe dynamic DOM insertions (e.g. TrustMate widget render)
    if ('MutationObserver' in window) {
        const observer = new MutationObserver(() => scheduleSanitize());
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-selected', 'role'],
        });
    }
}
